import { render, staticRenderFns } from "./UserPhotosSelector.vue?vue&type=template&id=9e378048&"
import script from "./UserPhotosSelector.vue?vue&type=script&lang=js&"
export * from "./UserPhotosSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports